export default __webpack_public_path__ + "static/media/letmeask-gif.2848fde8.gif";